import { useLastProductListingPath } from "@/lib/hooks/useLastProductListingPath";
import { useTranslation } from "@/lib/translations";
import { useRouter } from "next/router";
import React from "react";
import { ButtonContainer } from "@/components/ProductDetail/GoBack/styles";

const GoBack: React.FC = () => {
  const { locale = "it" } = useRouter();

  const label = useTranslation("page.goBack", locale);
  const href = useLastProductListingPath();

  return (
    <ButtonContainer href={href}>{label || ""}</ButtonContainer>
  );
};

export default GoBack;
